import React from 'react'
import { Link } from 'react-router-dom'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { InventoryBySerialNumberStatus } from '../Status/InventoryBySerialNumberStatus'
import { Stack } from 'react-bootstrap'
import type { InventoryBySerialNumber } from '@ztechapps/common.contract'

export type InventoryBySerialNumberWidgetProps = Partial<InventoryBySerialNumber> & {
  linkTo?: string
  children?: React.ReactNode
}

export const InventoryBySerialNumberWidget = ({
  code,
  status,
  linkTo,
  product,
  batchCode,
  transactionType,
  children,
}: InventoryBySerialNumberWidgetProps) => {
  const codeComponent = <b>{code}</b>

  const productCode = product?.code
  const batchInfo = batchCode ? `Batch: ${batchCode}` : null

  return (
    <Stack gap={1}>
      <HorizontalStack gap={2}>
        <InventoryBySerialNumberStatus status={status} />
        <ShowIf condition={!!linkTo}>
          <Link to={linkTo}>{codeComponent}</Link>
        </ShowIf>
        <ShowIf condition={!linkTo}>{codeComponent}</ShowIf>
        <ShowIf condition={!!transactionType}>
          <small className="text-muted">({transactionType})</small>
        </ShowIf>
      </HorizontalStack>
      <ShowIf condition={!!productCode}>
        <div>{productCode}</div>
      </ShowIf>
      <ShowIf condition={!!batchInfo}>
        <div className="text-muted small">{batchInfo}</div>
      </ShowIf>

      {children}
    </Stack>
  )
}
